// extracted by mini-css-extract-plugin
module.exports = {"bubblecharts-container":"BubbleChartsContainer_bubblecharts-container__2RZtR","group":"BubbleChartsContainer_group__2HpiM","bubblechart":"BubbleChartsContainer_bubblechart__370rD"};